module.exports = __webpack_public_path__ + "static/ufo_about-018c104204e75f93653c9645049997cf.png";